var postal = require("common/PubSub");

function FileTransferManager(fileTransferDialog) {
    var self = this;

    var uploads = {};
    var nextUploadId = 0;
    var electronChannel = postal.channel("Electron");

    const ACCESS_DENIED = 5;
    const INVALID_CREDENTIALS = 8;
    const FILE_NOT_FOUND = 9;
    const FILE_ALREADY_EXISTS = 16;
    const DYNAMIC_APP_NOT_ENABLED = 21;

    const errorMessages = {
        [ACCESS_DENIED] : "common::vfs.accessDenied.message",
        [INVALID_CREDENTIALS] : "common::vfs.invalidCreds.title",
        [FILE_NOT_FOUND] : "common::vfs.fileNotFound.message",
        [FILE_ALREADY_EXISTS] : "common::vfs.fileAlreadyExists.message",
        [DYNAMIC_APP_NOT_ENABLED] : "common::dynamicApp.not.enabled"
    };

    function getUploadsAsArray() {
        var arr = [];

        for (var key in uploads) {
            if (uploads.hasOwnProperty(key)) {
                arr.push(uploads[key]);
            }
        }

        return arr;
    }

    function updateUploadState(files, changes) {
        files.forEach(function(file) {
            var transfer = uploads[file.fileTransferID];

            if (transfer) {
                for (var key in changes) {
                    if (changes.hasOwnProperty(key)) {
                        transfer[key] = changes[key];
                    }
                }

                electronChannel.publish("transfers-progress-update", transfer);
                postal.channel("VFSController").publish("transfer-progress-update", transfer);
            }
        });
    }

    function showDialog() {
        fileTransferDialog.setTransfers(getUploadsAsArray());
        CudaLaunch.navManager.show(fileTransferDialog, undefined, true);
    }

    this.download = function(uri, name) {
        $.fileDownload(uri, {
            failCallback : function(html) {
                let response = JSON.parse($(html).text());
                let failReason = errorMessages[response.code] || "common::vfs.operationFailed.message";

                CudaLaunch.controllers.RootController.showErrorDialog($.t("common::vfs.downloadFailed.message", {0 : name}) + "\n\n" + $.t(failReason), false, undefined,
                    function() {
                        if (response.code === DYNAMIC_APP_NOT_ENABLED) {
                            postal.channel("VFSController").publish("close-vfs");
                        }
                    }
                );
            }
        });
    };

    this.upload = function(vfsId, targetDir) {
        // Create a hidden input element to be used by the jQuery plugin
        var form = $('<form action="javascript:;" enctype="multipart/form-data" method="post" accept-charset="utf-8">');
        var hiddenInput = $('<input type="file" name="files[]" multiple>');
        form.append(hiddenInput);

        // Initialise the upload plugin
        hiddenInput.fileupload({
            url : "/sslvpn_api/vfs/upload",
            progressInterval : 500,
            dropZone : null,

            add : function(e, data) {
                data.files.forEach(function(file) {
                    var transfer = {
                        transferId : nextUploadId++,
                        transferType : "upload",
                        status : "pending",
                        filename : file.name,
                        transferred : 0,
                        totalBytes : file.size,
                        targetDir : targetDir
                    };
                    file.fileTransferID = transfer.transferId;
                    transfer.jqXHR = data.submit();

                    uploads[transfer.transferId] = transfer;

                    electronChannel.publish("transfers-progress-update", transfer);
                });
            },

            submit : function(e, data) {
                var sizes = [];
                data.files.forEach(function(file) {
                    sizes.push(file.size);
                });

                var session = CudaLaunch.serverConfiguration.getSession();

                // Even though the CSRF token is added automatically later on, we have
                // to put it in before the file contents are added to the request
                data.formData = [
                    {name : session.key, value : session.token},
                    {name : "vfsId", value : vfsId},
                    {name : "destination", value : targetDir},
                    {name : "sizes[]", value : JSON.stringify(sizes)}
                ];
            },

            progress : function(e, data) {
                updateUploadState(data.files, {
                    status : "transferring",
                    transferred : data.loaded,
                    progress : ((data.loaded / data.total) * 100).toFixed(0)
                });
            },

            done : function(e, data) {
                updateUploadState(data.files, {
                    status : "completed"
                });
            },

            fail : function(e, data) {
                updateUploadState(data.files, {
                    status : (data.errorThrown == "abort") ? "cancelled" : "failed"
                });
            },

            start : showDialog,

            stop : function() {
                try {
                    hiddenInput.fileupload("destroy");
                } catch (error) {
                    console.debug(error.message);
                }
            }
        });

        // Trigger the native file chooser
        hiddenInput.trigger("click");
    };

    this.open = function(transferId) {
    };

    this.cancel = function(transferId) {
        var transfer = uploads[transferId];

        if (transfer) {
            transfer.jqXHR.abort();
        }
    };

    this.getTransferDetails = function(transferId) {
        if (transferId !== undefined) {
            return $.Deferred().resolve(uploads[transferId] || {}).promise();
        }

        return $.Deferred().resolve(getUploadsAsArray()).promise();
    };

    this.getActiveTransferCount = function() {
        var active = 0;

        for (var key in uploads) {
            if (uploads.hasOwnProperty(key)
                && (uploads[key].status == "transferring" || uploads[key].status == "pending")) {
                active++;
            }
        }
        return $.Deferred().resolve(active).promise();
    };

    this.getViews = function() {
        return [fileTransferDialog];
    };

    postal.channel("FileTransferManager").subscribe("show-file-transfer-dialog", showDialog);

    electronChannel.subscribe("cancel-transfer", function(data) {
        self.cancel(data.transferId);
    });

    electronChannel.subscribe("remove-inactive-file-transfer", function(data) {
        delete uploads[data.transferId];
    });
}

module.exports = FileTransferManager;